import { getGridSumTableColumnsForInvestments } from '../../Investment';
import { AmountSumTableProps, GridSumTable } from '../../UI';
import { useQtInvestmentsSumTable, UseQtInvestmentsSumTableArgs } from '../hooks';
import { Investment, RecurringFrequency } from '../../generated/graphql';
import { amountToRecurring } from '../../util';

interface QtHealthcareInvestmentsSumTableProps
  extends UseQtInvestmentsSumTableArgs,
    Pick<AmountSumTableProps, 'className' | 'hideOnEmpty'> {
  onClickItem?: (investment: Investment) => void;
}

export function QtHealthcareInvestmentsSumTable({
  className,
  hideOnEmpty,
  onClickItem,
  ...useQtHealthcareInvestmentsSumTableArgs
}: QtHealthcareInvestmentsSumTableProps) {
  const { afterUpdate, isLoading, qtDetails, tUI, tInvestment } = useQtInvestmentsSumTable(
    useQtHealthcareInvestmentsSumTableArgs
  );

  return (
    <GridSumTable
      title={tUI('qt-healthcare-investments-table-title')}
      sumTitle={tUI('qt-healthcare-investments-table-sum-title')}
      className={className}
      isLoading={isLoading}
      hideOnEmpty={hideOnEmpty ?? true}
      sum={qtDetails?.totalHealthcare}
      sumAppendix={amountToRecurring(qtDetails?.totalHealthcareSavings.monthly, RecurringFrequency.Monthly)}
      rows={qtDetails?.healthcareAccounts || []}
      columns={getGridSumTableColumnsForInvestments({
        tInvestment,
        tUI,
        onClickItem,
        afterUpdate,
      })}
    />
  );
}
